/* RESPONSIBLE TEAM: team-knowledge-foundations */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class DynamicContentVariationSerializer extends EmbercomBaseSerializer {
  serialize(snapshot: any, _options: any): Record<string, any> {
    let json: Record<string, any> = {};
    snapshot.eachAttribute((key: string) => {
      let value = snapshot.attr(key);
      if (value !== undefined) {
        json[this.keyForAttribute(key)] = value;
      }
    });
    return json;
  }
}
